import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-form-check',
  templateUrl: './form-check.component.html',
  styleUrls: ['./form-check.component.scss']
})
export class FormCheckComponent {

  @Input() appName: string;
  @Input() isAppChecked: boolean;
  @Output() isOnChange = new EventEmitter<boolean>();

  changeRadioVal(){
    this.isOnChange.emit(this.isAppChecked)
  }

}
